import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteAgreement($id: ID!) {
        deleteAgreement(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
